import React from 'react';
import {Platform, View} from 'react-native';
import Modal from 'react-native-modal';

import Icon from '/component/base/Icon';
import RadioButtonGroup from '/component/base/RadioButton/RadioButtonGroup';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import VolumePerformanceTestIDs from '/constant/TestIDs/VolumePerformance';
import {useTranslation} from '/provider/TranslationProvider';

import {sanitize} from '../constants/volumePerformanceReport.constants';
import {styles} from '../styles/VolPerfSortPopup.style';
import {VolPerfSortPopupProps} from '../types/VolPerfComponent.types';

export const VolPerfSortPopup: React.FC<VolPerfSortPopupProps> = ({
  isVisible,
  onClose,
  onSelect,
  selectedOptionId,
  options,
}) => {
  const {tt} = useTranslation('report.allOrdersSortButton');

  const radioOptions = options.map(option => ({
    text: option.label,
    selected: selectedOptionId === option.id,
    onPress: () => onSelect(option.id),
    testID: `vol-perf-sort-option-${sanitize(option.id)}`,
  }));

  return (
    <Modal
      isVisible={isVisible}
      onBackdropPress={onClose}
      onBackButtonPress={onClose}
      style={styles.modal}
      animationIn={Platform.OS === 'web' ? 'slideInRight' : 'slideInUp'}
      animationOut={Platform.OS === 'web' ? 'slideOutRight' : 'slideOutDown'}
      useNativeDriver
      hideModalContentWhileAnimating
      accessibilityViewIsModal={true}
      aria-modal={true}>
      <View style={styles.container}>
        <View style={styles.header}>
          <TouchableOpacity
            onPress={onClose}
            testID={VolumePerformanceTestIDs.volPerfCloseSort}
            accessible={true}
            accessibilityLabel="Close sort menu"
            accessibilityRole="button">
            <Icon name="close" style={styles.closeIcon} />
          </TouchableOpacity>
          <Text style={styles.headerTitle} isBold accessibilityRole="header">
            {tt('sort', 'Sort by')}
          </Text>
        </View>

        <View style={styles.content}>
          <RadioButtonGroup
            title={tt('options', 'Options')}
            options={radioOptions}
          />
        </View>
      </View>
    </Modal>
  );
};

export default VolPerfSortPopup;
